import { render } from "./OrdersMap.vue?vue&type=template&id=af3b7cac&ts=true"
import script from "./OrdersMap.vue?vue&type=script&lang=ts"
export * from "./OrdersMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__